module.exports = __webpack_public_path__ + "img/3.59a4f16c.png";